export function serializeFiltro (nome, filtro) {
  let query = ''
  for (let i = 0; i < filtro.length; i++) {
    if (i === 0) query = query + nome
    query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
    if (i < filtro.length - 1) query = query + `&${nome}`
  }
  query = query.replace(/%2C/g, ',')
  return query
}

export function serializePesquisa (nome, dados) {
  let query = ''
  for (let i = 0; i < dados.length; i++) {
    if (i === 0) {
      query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(dados[i]))
    } else {
      query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(dados[i]))
    }
  }
  return query + '%5D'
}

export function serializePaginate (dados) {
  if (dados) {
    const keys = Object.keys(dados)
    let query = ''
    for (let i = 0; i < keys.length; i++) {
      query = query + keys[i] + '=' + dados[keys[i]]
      if (i !== keys.length - 1) query = query + '&'
    }
    return query
  }
  return dados
}
